import Image from 'next/image';
import { Box } from '@react/chakra';

import type { JSX } from 'react';

import { KofiModal } from './KofiModal';

export function KofiImage(): JSX.Element {
  return (
    <KofiModal
      trigger={
        <Box asChild cursor='pointer'>
          <Image width={1048} height={524} alt='kofi.webp' src='/kofi.webp' />
        </Box>
      }
    />
  );
}
